import { render, staticRenderFns } from "./ActionComponent.vue?vue&type=template&id=e32f34ac"
import script from "./ActionComponent.vue?vue&type=script&lang=ts"
export * from "./ActionComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports